"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayBasedOnRoles = void 0;
var shouldDisplayBasedOnRoles = function shouldDisplayBasedOnRoles() {
  var hiddenForRoles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var userRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!userRoles.length || !hiddenForRoles) {
    return true;
  }
  var shouldDisplay = true;
  var containsOR = hiddenForRoles.match(/\bOR\b/);
  var containsAND = hiddenForRoles.match(/\bAND\b/);
  var containsNOT = hiddenForRoles.match(/\NOT\b/);
  var orRoles = containsOR ? hiddenForRoles.split(/\b\s*OR\s*\b/) : [];
  var andRoles = containsAND ? hiddenForRoles.split(/\b\s*AND\s*\b/) : [];

  //page is hidden for a single role
  if (!containsOR && !containsAND) {
    //is it negated?
    if (containsNOT) {
      var match = hiddenForRoles.match(/^NOT\s+(.+)/);
      var negatedRole = match && match.length > 0 ? match[1] : '';
      return userRoles.indexOf(negatedRole) > -1;
    }
    return userRoles.indexOf(hiddenForRoles) === -1;
  }

  //contains AND queries (ROLE1 AND ROLE2 AND..)
  if (containsAND) {
    //contains negations (AND...AND NOT...)
    if (containsNOT) {
      var andRolesCopy = andRoles.filter(function (role) {
        return role.match(/^(?!NOT\s+)/);
      });
      var andNegatedRoles = andRoles.filter(function (role) {
        return role.match(/^NOT\s+/);
      }).map(function (role) {
        return role.replace(/^NOT\s+/, '');
      });
      if (andRolesCopy.every(function (role) {
        return userRoles.indexOf(role) > -1;
      }) && userRoles.every(function (userRole) {
        return andNegatedRoles.indexOf(userRole) === -1;
      })) {
        shouldDisplay = false;
      }
    }
    // no negations. If ALL userRoles are contained on AND roles array, then the page shouldn't be displayed
    else if (userRoles.every(function (userRole) {
      return andRoles.indexOf(userRole) > -1;
    })) {
      shouldDisplay = false;
    }
  }
  //contains OR queries (ROLE1 AND ROLE2 AND..)
  else if (containsOR) {
    //contains negations (OR...OR NOT...)
    if (containsNOT) {
      var orRolesCopy = orRoles.filter(function (role) {
        return role.match(/^(?!NOT\s+)/);
      });
      var orNegatedRoles = orRoles.filter(function (role) {
        return role.match(/^NOT\s+/);
      }).map(function (role) {
        return role.replace(/^NOT\s+/, '');
      });
      if (userRoles.some(function (userRole) {
        return orRolesCopy.indexOf(userRole) > -1;
      }) || userRoles.every(function (userRole) {
        return orNegatedRoles.indexOf(userRole) === -1;
      })) {
        shouldDisplay = false;
      }
    }
    // no negations. If at least 1 userRoles are contained on OR roles array, then the page shouldn't be displayed
    else if (userRoles.some(function (userRole) {
      return orRoles.indexOf(userRole) > -1;
    })) {
      shouldDisplay = false;
    }
  }
  return shouldDisplay;
};
exports.shouldDisplayBasedOnRoles = shouldDisplayBasedOnRoles;